import axios from "axios";
import { API_ELSTIC_URL, API_BASE_URL } from "../../config";
import { authHeaders } from "../utils/session";

const jsonHeaders = () => ({
  ...authHeaders(),
});

const BASE = `${API_ELSTIC_URL}/cms/support/tickets`;

export const fetchTickets = async (page = 1, limit = 15, filters = {}) => {
  const params = { limit, offset: (page - 1) * limit };
  if (filters.search)   params.search   = filters.search;
  if (filters.status)   params.status   = filters.status;
  if (filters.priority) params.priority = filters.priority;
  if (filters.type)     params.type     = filters.type;

  const res = await axios.get(BASE, { params, headers: jsonHeaders() });
  return res.data;
};

export const fetchTicketDetail = async (id) => {
  const res = await axios.get(`${BASE}/${id}`, { headers: jsonHeaders() });
  return res.data;
};

export const updateTicketStatus = async (id, status, remarks = "") => {
  const body = { status };
  if (remarks?.trim()) body.remarks = remarks.trim();
  const res = await axios.patch(
    `${BASE}/${id}/status`,
    body,
    { headers: jsonHeaders() },
  );
  return res.data;
};
